import script from "./StepSpecifics.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSpecifics.vue?vue&type=script&setup=true&lang=js"

import "./StepSpecifics.vue?vue&type=style&index=0&id=1aba579c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aba579c"]])

export default __exports__